import { pdf } from "@react-pdf/renderer";
import Bill from "./Bill";
import toast from "react-hot-toast";
import { CompanyInfo } from "../../../models/quotationData.model";
import { IProduct } from "../../../models/productData.model";
import { OrderConfirmationPDF } from "../../../pages/EpcQuotation/OrderConfirmationPDF";
import { CustomerOrder, OrderItem } from "../../../models/Order.model";
import { calculateOrderTotals } from "../../../utils/orderTotals";

const createPdfFileName = (companyInfo: CompanyInfo, isPI: boolean): string => {
  const customerName = (companyInfo.name || "Customer")
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  const documentNumber = isPI
    ? companyInfo.orderNumber
    : companyInfo.quotationNumber;
  const safeDocumentNumber = documentNumber
    ?.trim()
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  const documentType = isPI ? "PI" : "Quote";

  return `${customerName || "Customer"}_${documentType}_${safeDocumentNumber || "Document"}.pdf`;
};

export const HandPrintAndDownload = async (
  bookedProducts: IProduct[] | any[],
  companyInfo: CompanyInfo,
  trasnportPrice?: number,
  discountPrice?: number,
  isPI = false,
): Promise<void> => {
  try {
    if (bookedProducts.length <= 0) {
      toast.error("Please Add Goods");
      return;
    }

    let billDocument;

    if (!isPI) {
      billDocument = (
        <Bill
          trasnportPrice={trasnportPrice}
          discountPrice={discountPrice}
          bookedProducts={bookedProducts}
          companyInfo={companyInfo}
        />
      );
    } else {
      const orderItems: OrderItem[] = bookedProducts.map((item) => ({
        productName: item.productName,
        price: item.price ?? 0,
        quantity: item.quantity,
        transportPrice: trasnportPrice,
        discountPrice: item.discount || 0,
      }));

      const customerOrders: CustomerOrder[] = bookedProducts.map((item) => ({
        _id: item._id,
        productName: item.productName,
        hsn: item.hsn ?? 0,
        price: item.price ?? 0,
        gst: item.gst ?? 0,
        productId: item,
        quantity: item.quantity,
        transportPrice: trasnportPrice,
        discountPrice: item.discount || 0,
      }));

      const grandTotalForPdf = calculateOrderTotals(
        orderItems,
        customerOrders,
      ).grandTotal;
      billDocument = (
        <OrderConfirmationPDF
          orderItems={orderItems}
          customerInfo={companyInfo}
          customerOrders={customerOrders.map((order) => ({
            ...order,
            productId:
              typeof order.productId === "string"
                ? ({} as IProduct)
                : order.productId,
          }))}
          grandTotal={grandTotalForPdf}
          transportPrice={trasnportPrice}
          discountPrice={discountPrice}
        />
      );
    }

    const pdfBlob = await pdf(billDocument).toBlob();
    const fileName = createPdfFileName(companyInfo, isPI);
    const url = URL.createObjectURL(pdfBlob);

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      window.open(url, "_blank");
    } else {
      const iframe = document.createElement("iframe");
      iframe.title = fileName;
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.src = url;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        if (iframe.contentDocument) {
          iframe.contentDocument.title = fileName.replace(/\.pdf$/i, "");
        }
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};
